import { render } from "./ClassroomList.vue?vue&type=template&id=59a6506d&scoped=true"
import script from "./ClassroomList.vue?vue&type=script&lang=js"
export * from "./ClassroomList.vue?vue&type=script&lang=js"

import "./ClassroomList.vue?vue&type=style&index=0&id=59a6506d&scoped=true&lang=css"

import exportComponent from "../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a6506d"]])

export default __exports__